import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0b8d2331"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "serviceStatus" }
const _hoisted_2 = { key: 0 }

import { ServiceStatusType } from '../../types/ServiceStatusType';
import { GetServiceStatus } from '.';
import { Icon } from '../../Atoms';


export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceStatus',
  props: {
    status: {},
    showLabel: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const serviceStatus = () => GetServiceStatus(props.status);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Icon), {
      "icon-name": serviceStatus().name,
      md: true
    }, null, 8, ["icon-name"]),
    (_ctx.showLabel)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(serviceStatus().text), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})